
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { PlusCircle, User } from 'lucide-react';

interface DashboardHeaderProps {
  userFullName: string;
  onLogout: () => void;
  onCreateEvent?: () => void;
}

const DashboardHeader = ({ userFullName, onLogout, onCreateEvent }: DashboardHeaderProps) => {

  return (
    <header className="mb-8">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Szervező vezérlőpult</h1>
          <p className="text-gray-600 mt-2">Üdvözöljük, {userFullName}!</p>
        </div>
        <div className="flex gap-3">
          {onCreateEvent && (
            <Button
              onClick={onCreateEvent}
              className="flex items-center gap-2"
            >
              <PlusCircle className="h-4 w-4" />
              Új esemény
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
